/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoCustomerNumber } from './HeoCustomerNumber';
import {
    HeoCustomerNumberFromJSON,
    HeoCustomerNumberFromJSONTyped,
    HeoCustomerNumberToJSON,
    HeoCustomerNumberToJSONTyped,
} from './HeoCustomerNumber';
import type { ContactDetails } from './ContactDetails';
import {
    ContactDetailsFromJSON,
    ContactDetailsFromJSONTyped,
    ContactDetailsToJSON,
    ContactDetailsToJSONTyped,
} from './ContactDetails';
import type { ContactPermissions } from './ContactPermissions';
import {
    ContactPermissionsFromJSON,
    ContactPermissionsFromJSONTyped,
    ContactPermissionsToJSON,
    ContactPermissionsToJSONTyped,
} from './ContactPermissions';

/**
 * 
 * @export
 * @interface AccountDetails
 */
export interface AccountDetails {
    /**
     * 
     * @type {string}
     * @memberof AccountDetails
     */
    id: string;
    /**
     * 
     * @type {HeoCustomerNumber}
     * @memberof AccountDetails
     */
    customerNumber: HeoCustomerNumber;
    /**
     * 
     * @type {string}
     * @memberof AccountDetails
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetails
     */
    email: string;
    /**
     * 
     * @type {ContactDetails}
     * @memberof AccountDetails
     */
    contactDetails: ContactDetails;
    /**
     * 
     * @type {ContactPermissions}
     * @memberof AccountDetails
     */
    contactPermissions: ContactPermissions;
}

/**
 * Check if a given object implements the AccountDetails interface.
 */
export function instanceOfAccountDetails(value: object): value is AccountDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('customerNumber' in value) || value['customerNumber'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('contactDetails' in value) || value['contactDetails'] === undefined) return false;
    if (!('contactPermissions' in value) || value['contactPermissions'] === undefined) return false;
    return true;
}

export function AccountDetailsFromJSON(json: any): AccountDetails {
    return AccountDetailsFromJSONTyped(json, false);
}

export function AccountDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'customerNumber': HeoCustomerNumberFromJSON(json['customerNumber']),
        'username': json['username'],
        'email': json['email'],
        'contactDetails': ContactDetailsFromJSON(json['contactDetails']),
        'contactPermissions': ContactPermissionsFromJSON(json['contactPermissions']),
    };
}

export function AccountDetailsToJSON(json: any): AccountDetails {
    return AccountDetailsToJSONTyped(json, false);
}

export function AccountDetailsToJSONTyped(value?: AccountDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customerNumber': HeoCustomerNumberToJSON(value['customerNumber']),
        'username': value['username'],
        'email': value['email'],
        'contactDetails': ContactDetailsToJSON(value['contactDetails']),
        'contactPermissions': ContactPermissionsToJSON(value['contactPermissions']),
    };
}

